module.exports = __webpack_public_path__ + "static/img/icon_rhime.3f80895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_rhime.png
// module id = 379
// module chunks = 1